import { PAGE_URLS } from "./PageUrls";
import { BACKOFFICE_PERMISSIONS } from "./Permissions";
import { TRANSLATION_KEYS } from "./TranslationKeys";

import type { RouteCan } from "routes/RouteModel";
import type { ObjectValuesAsType } from "utils/types";

export const BACKOFFICE_SECTION = {
  TRANSACTIONS: "transactions",
} as const;

export type BackofficeSectionId = ObjectValuesAsType<typeof BACKOFFICE_SECTION>;

export interface BackofficeSection {
  id: BackofficeSectionId;
  permission: RouteCan;
  titleKey: string;
  url: string;
}

// The sections of the Accounts backoffice, in tab order. The page tabs, the
// sidebar entry and the landing redirect all read this list, so a new section
// (Reversals, Accounts, Treasury, System) is one entry here plus its route.
// Each section has its own permission: a user only sees the sections they may
// open, and lands on the first of them.
export const BACKOFFICE_SECTIONS: BackofficeSection[] = [
  {
    id: BACKOFFICE_SECTION.TRANSACTIONS,
    permission: BACKOFFICE_PERMISSIONS.transactionsList,
    titleKey: TRANSLATION_KEYS.transactions,
    url: PAGE_URLS.transactions,
  },
];

// The backoffice shows in the sidebar when any of its sections can be opened
export const BACKOFFICE_ACCESS_PERMISSIONS: RouteCan[] =
  BACKOFFICE_SECTIONS.map(({ permission }) => permission);
